(function () {
    'use strict';

    angular.module("imApp").factory("deviationTypeMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1228,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 1231,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
